import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

// TODO: Fill in your business address and phone number below
const BUSINESS_ADDRESS = "Noida, Gautam Buddha Nagar, U.P. - 201309"; // e.g. "123, ABC Tower, Connaught Place, New Delhi - 110001"
const BUSINESS_PHONE = "Use mail or in-built chat support";   // e.g. "+91 98765 43210"

const ContactPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            Contact Us
          </h1>
          <p className="text-sm opacity-60 mb-8">
            We're here to help with tax filing queries, document concerns, and account support.
          </p>

          <div className="grid md:grid-cols-2 gap-8 text-[15px] leading-7 opacity-90">

            <div className="space-y-5">
              <div>
                <p className="font-semibold mb-1">Support Email</p>
                <a
                  href="mailto:support@mooltax.com"
                  className="underline opacity-80"
                >
                  support@mooltax.com
                </a>
              </div>

              <div>
                <p className="font-semibold mb-1">Phone / WhatsApp</p>
                <a href={`tel:${BUSINESS_PHONE}`} className="opacity-80">
                  {BUSINESS_PHONE}
                </a>
              </div>

              <div>
                <p className="font-semibold mb-1">Business Hours</p>
                <p className="opacity-80">Monday to Saturday, 10:00 AM – 7:00 PM IST</p>
              </div>

              <div>
                <p className="font-semibold mb-1">Response Time</p>
                <p className="opacity-80">We aim to respond within 24–48 business hours.</p>
              </div>
            </div>

            <div className="space-y-5">
              <div>
                <p className="font-semibold mb-1">Operating or Registered Business Address</p>
                <p className="opacity-80 leading-8">{BUSINESS_ADDRESS}</p>
              </div>

              <div>
                <p className="font-semibold mb-1">For Refund Queries</p>
                <p className="opacity-80">
                  Email us at{" "}
                  <a href="mailto:support@mooltax.com" className="underline">
                    support@mooltax.com
                  </a>{" "}
                  with your payment reference number.
                </p>
              </div>
            </div>

          </div>

          <div
            className="mt-8 p-5 rounded-xl text-[14px] leading-6"
            style={{ backgroundColor: "var(--secondary)" }}
          >
            <p className="opacity-75">
              <strong>Note:</strong> For queries related to your filing case, please use the
              Messages section inside your dashboard for faster responses from your assigned team.
            </p>
          </div>

        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default ContactPage;
